WL.registerComponent('notification', {
}, {
    init: function() {
        this.text = this.object.getComponent('text');
        this.text.active = false;
    },
    notification: function(message, keepAlive = false) {
        this.text.active = true;
        this.text.text = message;
        if (!keepAlive) {
            setTimeout(() => {
              this.text.active = false;
            }, 2000);
        }
    },
});
